import DeviceGroupPage from './DeviceGroupPage';

export default DeviceGroupPage;
